import { render, staticRenderFns } from "./DocumentSectionComponent.vue?vue&type=template&id=f32367e8&"
import script from "./DocumentSectionComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentSectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSectionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports